var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',{attrs:{"page-sizes":[10],"layout":_vm.layout,"total":_vm.total - '',"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.handlePageChange}})}
var staticRenderFns = []

export { render, staticRenderFns }